const _ = require('lodash');
const cleanseInitials = require('./cleanseInitials');

function getInitials (names) {
  if (!names) return null;
  const nameParts = names.split(/\s+/g);
  const initials = nameParts.map(namePart => {
    const nameLetters = namePart.split('');
    return _.toUpper(nameLetters[0]);
  }).join('.');

  const cleansedInitials = cleanseInitials(initials);
  return cleansedInitials === '' ? null : cleansedInitials;
}

module.exports = getInitials;
